import { render, staticRenderFns } from "./BasePill.vue?vue&type=template&id=2df2b898"
import script from "./BasePill.vue?vue&type=script&lang=ts"
export * from "./BasePill.vue?vue&type=script&lang=ts"
import style0 from "./BasePill.vue?vue&type=style&index=0&id=2df2b898&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports